import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { xcss } from '@atlaskit/primitives';
import Pressable from '@atlaskit/primitives/pressable';
import { messages } from './messages';
var feedbackButtonStyles = xcss({
  backgroundColor: 'color.background.neutral.subtle',
  color: 'color.link',
  padding: 'space.0',
  ':hover': {
    textDecoration: 'underline',
    cursor: 'pointer'
  }
});
export var FeedbackButton = function FeedbackButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Pressable, {
    xcss: feedbackButtonStyles,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.feedbackButton));
};